import { parseOrThrow, type ApiClientDeps } from '@pay-roadrunner/api-client-core';
import type { FinancialYear, SaveSuperannuationSystemParameterSet, SuperannuationSystemParameter, SuperannuationSystemParametersClient } from './types';

const query = (values: Record<string, string | undefined>) => {
  const params = new URLSearchParams(); Object.entries(values).forEach(([key, value]) => { if (value) params.set(key, value); });
  return params.toString();
};

export const createAdminSuperannuationSystemParametersClient = (deps: ApiClientDeps): SuperannuationSystemParametersClient => {
  const request = deps.fetchImpl ?? fetch; const base = () => `${deps.getBaseUrl()}/api/superannuation-system-parameters`;
  return {
    financialYears: async (regionCode) => (await parseOrThrow<FinancialYear[]>(await request(`${base()}/financial-years?${query({ regionCode })}`))).result ?? [],
    parameters: async (regionCode, financialYear) => (await parseOrThrow<SuperannuationSystemParameter[]>(await request(`${base()}?${query({ regionCode, financialYear })}`))).result ?? [],
    save: async (body: SaveSuperannuationSystemParameterSet) => (await parseOrThrow<SuperannuationSystemParameter[]>(await request(base(), { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }))).result ?? [],
  };
};

export const createTenantSuperannuationSystemParametersClient = (deps: ApiClientDeps): SuperannuationSystemParametersClient => {
  const request = deps.fetchImpl ?? fetch; const base = (id: string) => `${deps.getBaseUrl()}/api/business-records/${encodeURIComponent(id)}/superannuation/system-parameters`;
  return {
    financialYears: async (_regionCode, id) => (await parseOrThrow<FinancialYear[]>(await request(`${base(id ?? '')}/financial-years`))).result ?? [],
    parameters: async (_regionCode, financialYear, id) => (await parseOrThrow<SuperannuationSystemParameter[]>(await request(`${base(id ?? '')}?${query({ financialYear })}`))).result ?? [],
  };
};
